import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from 'antd';
import type { TableProps } from 'antd/es/table';

const TableWrapper = (props: TableProps<Record<string, unknown>>): JSX.Element => {
	const { t } = useTranslation();
	return (
		<Table
			{...props}
			locale={{
				triggerDesc: t('common:action:sort_descending'),
				triggerAsc: t('common:action:sort_ascending'),
				cancelSort: t('common:action:sort_cancel'),
			}}
		/>
	);
};

export default TableWrapper;
